import {
  STATE_STATUS,
  GET_FUND_ACCOUNTS_ACTIONS,
  CREATE_FUND_ACCOUNT_BANK_ACTIONS,
  CREATE_FUND_ACCOUNT_VPA_ACTIONS,
  WITHDRAW_MONEY_ACTIONS,
  SET_CURRENT_FILTER,
  SET_CURRENT_WALLET_SCREEN,
  SET_WALLET_META_DATA,
  SET_WALLET_SUMMARY,
} from "./actionTypes";

const initState = {
  filters: [],
  walletStats: [],
  currentFilter: {
    key: "today",
    text: "आजका",
    data: null,
  },
  primaryAccBannerEnabled: false,
  primaryAccBannerUrl: null,
  currentScreen: null,
  terms: [],
  walletSummary: null,

  fundAccountsData: [],
  fundAccountStatus: STATE_STATUS.UNFETCHED,
  fundAccountsError: null,

  createFundAccountData: null,
  createFundAccountStatus: STATE_STATUS.NOT_CREATED,
  createFundAccountError: null,

  withdrawAmountData: [],
  withdrawAmountStatus: STATE_STATUS.NOT_CREATED,
  withdrawAmountError: null,
  isFirstLoad: true,
};

export const actions = {
  setCurrentFilter(key, data = null) {
    return {
      type: SET_CURRENT_FILTER,
      payload: {
        key,
        data,
      },
    };
  },
  setCurrentScreen(data = null) {
    return {
      type: SET_CURRENT_WALLET_SCREEN,
      payload: {
        data,
      },
    };
  },
  setWalletMetaData(data = null) {
    return {
      type: SET_WALLET_META_DATA,
      payload: {
        data,
      },
    };
  },
  setWalletSummary(data = null) {
    return {
      type: SET_WALLET_SUMMARY,
      payload: {
        data,
      },
    };
  },
  // FETCH FUND ACCOUNTS
  fetchFundAccounts() {
    return {
      type: GET_FUND_ACCOUNTS_ACTIONS.FETCH_FUND_ACCOUNTS,
    };
  },
  fetchedFundAccounts(data) {
    return {
      type: GET_FUND_ACCOUNTS_ACTIONS.FETCHED_FUND_ACCOUNTS,
      payload: {
        data,
      },
    };
  },
  failedFetchFundAccounts(error) {
    return {
      type: GET_FUND_ACCOUNTS_ACTIONS.FAILED_FETCH_FUND_ACCOUNTS,
      payload: {
        error,
      },
    };
  },
  // CREATE FUND ACCOUNT BANK
  createFundAccountBank(payload) {
    return {
      type: CREATE_FUND_ACCOUNT_BANK_ACTIONS.CREATE_FUND_ACCOUNT,
      payload,
    };
  },
  createdFundAccountBank(data) {
    return {
      type: CREATE_FUND_ACCOUNT_BANK_ACTIONS.SUCCESS_CREATE_FUND_ACCOUNTS,
      payload: {
        data,
      },
    };
  },
  failedCreateFundAccountBank(error) {
    return {
      type: CREATE_FUND_ACCOUNT_BANK_ACTIONS.FAILED_CREATE_FUND_ACCOUNT,
      payload: {
        error,
      },
    };
  },
  resetFundAccountBank() {
    return {
      type: CREATE_FUND_ACCOUNT_BANK_ACTIONS.RESET_CREATE_FUND_ACCOUNT,
    };
  },

  // CREATE FUND ACCOUNT VPA
  createFundAccountVpa(payload) {
    return {
      type: CREATE_FUND_ACCOUNT_VPA_ACTIONS.CREATE_VPA_FUND_ACCOUNT,
      payload,
    };
  },
  createdFundAccountVpa(data) {
    return {
      type: CREATE_FUND_ACCOUNT_VPA_ACTIONS.SUCCESS_CREATE_VPA_FUND_ACCOUNTS,
      payload: {
        data,
      },
    };
  },
  failedCreateFundAccountVpa(error) {
    return {
      type: CREATE_FUND_ACCOUNT_VPA_ACTIONS.FAILED_CREATE_VPA_FUND_ACCOUNT,
      payload: {
        error,
      },
    };
  },
  resetFundAccountVpa() {
    return {
      type: CREATE_FUND_ACCOUNT_VPA_ACTIONS.RESET_CREATE_VPA_FUND_ACCOUNT,
    };
  },

  // WITHDRAW MONEY
  withdrawMoney(payload) {
    return {
      type: WITHDRAW_MONEY_ACTIONS.WITHDRAW_MONEY,
      payload,
    };
  },
  successWithdrawMoney(data) {
    return {
      type: WITHDRAW_MONEY_ACTIONS.SUCCESS_WITHDRAW_MONEY,
      payload: {
        data,
      },
    };
  },
  failedWithdrawMoney(error) {
    return {
      type: WITHDRAW_MONEY_ACTIONS.FAILED_WITHDRAW_MONEY,
      payload: {
        error,
      },
    };
  },
  resetWithdrawMoney() {
    return {
      type: WITHDRAW_MONEY_ACTIONS.RESET_WITHDRAW_MONEY,
    };
  },
};

const oldWalletReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CURRENT_FILTER: {
      const { key, data = {} } = action.payload;

      const currentFilter = state.filters.find(
        // eslint-disable-next-line no-shadow
        (currentFilter) => currentFilter.key === key,
      );

      return {
        ...state,
        currentFilter: {
          ...(currentFilter || state.currentFilter),
          ...data,
        },
      };
    }

    case SET_CURRENT_WALLET_SCREEN: {
      const { data = null } = action.payload;

      return {
        ...state,
        currentScreen: data,
      };
    }

    case SET_WALLET_META_DATA: {
      const { data = {} } = action.payload;
      const {
        terms = [],
        filters: { availableFilters = [], default: defaultFilter = {} } = {},
        primary_acc_banner_enabled = false,
        primary_acc_banner_url = null,
      } = data;

      const allFilters = availableFilters.map((filter) => {
        filter.text = filter.label;
        delete filter.label;
        return filter;
      });

      return {
        ...state,
        terms,
        filters: allFilters,
        currentFilter: defaultFilter,
        primaryAccBannerEnabled: primary_acc_banner_enabled,
        primaryAccBannerUrl: primary_acc_banner_url,
      };
    }

    case SET_WALLET_SUMMARY: {
      const { data = {} } = action.payload;

      return {
        ...state,
        walletSummary: data,
        isFirstLoad: false,
      };
    }

    /// /////////////////////// FETCH FUND POINTS /////////////////////////
    case GET_FUND_ACCOUNTS_ACTIONS.FETCH_FUND_ACCOUNTS: {
      return {
        ...state,
        fundAccountStatus: STATE_STATUS.FETCHING,
      };
    }
    case GET_FUND_ACCOUNTS_ACTIONS.FETCHED_FUND_ACCOUNTS: {
      return {
        ...state,
        fundAccountsData: action.payload.data,
        fundAccountStatus: STATE_STATUS.FETCHED,
        fundAccountsError: null,
      };
    }
    case GET_FUND_ACCOUNTS_ACTIONS.FAILED_FETCH_FUND_ACCOUNTS: {
      return {
        ...state,
        fundAccountsData: [],
        fundAccountStatus: STATE_STATUS.FETCH_FAILED,
        fundAccountsError: action.payload.error,
      };
    }

    /// /////////////////////// CREATE FUND ACCOUNTS /////////////////////////
    case CREATE_FUND_ACCOUNT_BANK_ACTIONS.CREATE_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountStatus: STATE_STATUS.CREATING,
      };
    }
    case CREATE_FUND_ACCOUNT_BANK_ACTIONS.SUCCESS_CREATE_FUND_ACCOUNTS: {
      return {
        ...state,
        createFundAccountData: action.payload.data,
        createFundAccountStatus: STATE_STATUS.CREATED,
        createFundAccountError: null,
      };
    }
    case CREATE_FUND_ACCOUNT_BANK_ACTIONS.FAILED_CREATE_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountData: [],
        createFundAccountStatus: STATE_STATUS.CREATE_FAILED,
        createFundAccountError: action.payload.error,
      };
    }
    case CREATE_FUND_ACCOUNT_BANK_ACTIONS.RESET_CREATE_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountData: [],
        createFundAccountStatus: STATE_STATUS.NOT_CREATED,
        createFundAccountError: null,
      };
    }

    /// /////////////////////// CREATE FUND VPA ACCOUNTS /////////////////////////
    case CREATE_FUND_ACCOUNT_VPA_ACTIONS.CREATE_VPA_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountStatus: STATE_STATUS.CREATING,
        // withdrawAmountStatus: STATE_STATUS.CREATING,
      };
    }
    case CREATE_FUND_ACCOUNT_VPA_ACTIONS.SUCCESS_CREATE_VPA_FUND_ACCOUNTS: {
      return {
        ...state,
        createFundAccountData: action.payload.data,
        createFundAccountStatus: STATE_STATUS.CREATED,
        createFundAccountError: null,
      };
    }
    case CREATE_FUND_ACCOUNT_VPA_ACTIONS.FAILED_CREATE_VPA_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountData: [],
        createFundAccountStatus: STATE_STATUS.CREATE_FAILED,
        createFundAccountError: action.payload.error,
      };
    }
    case CREATE_FUND_ACCOUNT_VPA_ACTIONS.RESET_CREATE_VPA_FUND_ACCOUNT: {
      return {
        ...state,
        createFundAccountData: [],
        createFundAccountStatus: STATE_STATUS.NOT_CREATED,
        createFundAccountError: null,
      };
    }

    /// /////////////////////// WITHDRAW FUNDS /////////////////////////
    case WITHDRAW_MONEY_ACTIONS.WITHDRAW_MONEY: {
      return {
        ...state,
        withdrawAmountStatus: STATE_STATUS.CREATING,
      };
    }
    case WITHDRAW_MONEY_ACTIONS.SUCCESS_WITHDRAW_MONEY: {
      return {
        ...state,
        withdrawAmountData: action.payload.data,
        withdrawAmountStatus: STATE_STATUS.CREATED,
        withdrawAmountError: null,
      };
    }
    case WITHDRAW_MONEY_ACTIONS.FAILED_WITHDRAW_MONEY: {
      return {
        ...state,
        withdrawAmountData: [],
        withdrawAmountStatus: STATE_STATUS.CREATE_FAILED,
        withdrawAmountError: action.payload.error,
      };
    }
    case WITHDRAW_MONEY_ACTIONS.RESET_WITHDRAW_MONEY: {
      return {
        ...state,
        withdrawAmountData: [],
        withdrawAmountStatus: STATE_STATUS.NOT_CREATED,
        withdrawAmountError: null,
      };
    }

    default:
      return state;
  }
};
oldWalletReducer.initialState = initState;

export default oldWalletReducer;
